module.exports = __webpack_public_path__ + "static/img/Fasting Blood Sugar FBS.7c3a83a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/specialities/Fasting Blood Sugar FBS.svg
// module id = pUkD
// module chunks = 7